// Internal modules
import { getContent } from '@/lib/content';
import { formatFraction } from '@/components/Interstitials/InstallmentInterstitial/utils';

export const getInstallmentButtonLabel = ({
  shouldShowIC2B,
  selectedInstallment,
  term,
}) => {
  if (!term || !selectedInstallment) {
    return shouldShowIC2B
      ? getContent('installments.installmentButtonLabel')
      : getContent('installments.buttonLabel');
  }
  const amount =
    selectedInstallment.monthlyPayment.currencyFormatSymbolISOCurrency;

  const selectedInstallmentSelector = shouldShowIC2B
    ? 'installments.selectedInstallmentContent'
    : 'installments.selectedInstallment';
  return getContent(selectedInstallmentSelector, {
    amount,
    term,
  });
};

export const getDiscountOrConsumerFeeLabel = selectedInstallment => {
  const totalConsumerFee =
    selectedInstallment?.totalConsumerFee?.amount
      ?.currencyFormatSymbolISOCurrency;

  if (totalConsumerFee) {
    return getContent('installments.consumerFeeLabel', {
      totalConsumerFee,
    });
  }
  if (selectedInstallment?.discount) {
    const discountPercent = formatFraction(
      selectedInstallment?.discount?.percentage,
    );
    return `(${getContent('installments.discountPercentLabel', {
      discountPercent,
    })})`;
  }
  return '';
};
